import Image1 from "../../assets/testimonial1.png";
import Image2 from "../../assets/testimonial2.png";
import Image3 from "../../assets/testimonial3.png";

export const Data = [
    {
      id: 1,
      image: Image1,
      title: "Hamid Afghan",
      description:
        "I am very happy with the work done, I recommend it, they are very professional and responsible."
    },
    {
      id: 2,
      image: Image2,
      title: "Alireza Mohseni",
      description:
        "He has done a great job, he has been very attentive and has done everything I asked him, I recommend him 100%.",
    },
    {
      id: 3,
      image: Image3,
      title: "Azizullah Saiedi",
      description:
        "The work has been done very well, I am very happy with the result, I recommend it."
    },
  ];
  